module.exports = __webpack_public_path__ + "img/nosearchmatch.21d30792.svg";